module.exports = __webpack_public_path__ + "img/speaker38.86eb6382.png";